<template>
  <div class="text-field">
    <FieldLabel
      :id="fieldConfig && fieldConfig.id"
      :label="fieldConfig && fieldConfig.label"
      :description="fieldConfig && fieldConfig.description"
      :required="fieldConfig && fieldConfig.required"
    />
    <input
      :id="fieldConfig && fieldConfig.id"
      ref="input"
      :type="htmlInputType"
      class="field-input"
      :placeholder="fieldConfig && fieldConfig.placeholder"
      :disabled="fieldConfig && fieldConfig.disabled"
      :required="fieldConfig && fieldConfig.required"
      :maxlength="maxLengthProp"
      :aria-invalid="hasError ? 'true' : 'false'"
      @input="onInput"
      @change="stopNativeChange"
    />
    <label
      v-if="hasError"
      :for="fieldConfig && fieldConfig.id"
      class="field-error"
    >
      {{ errorMessage }}
    </label>
  </div>
</template>

<script>
import FieldLabel from "../FieldLabel/FieldLabel.vue";
import errorDisplay from "../mixins/errorDisplay.js";
import nativeChangeGuard from "../mixins/nativeChangeGuard.js";
import vModelHelpers from "../mixins/vModelHelpers.js";

export default {
  name: "TextField",
  components: {
    FieldLabel,
  },
  mixins: [errorDisplay, nativeChangeGuard, vModelHelpers],
  props: {
    fieldConfig: {
      type: Object,
      default: () => ({
        id: "text-field",
        name: "",
        type: "text",
        inputType: "plain",
        label: "",
        placeholder: "",
        required: false,
        width: "FULL",
        disabled: false,
        maxLength: undefined,
      }),
    },
    value: {
      type: [String, Number],
      default: null,
    },
    modelValue: {
      type: [String, Number],
      default: undefined,
    },
  },
  data() {
    return {
      internalValue: this.initialFromModel(this.modelValue, this.value, ""),
    };
  },
  computed: {
    htmlInputType() {
      const inputKind = this.fieldConfig && this.fieldConfig.inputType;
      if (inputKind === "email") return "email";
      if (inputKind === "tel") return "tel";
      if (inputKind === "url") return "url";
      return "text";
    },
    maxLengthProp() {
      const maxLength = this.fieldConfig && this.fieldConfig.maxLength;
      return typeof maxLength === "number" ? maxLength : null;
    },
  },
  watch: {
    value(newValue) {
      if (this.modelValue !== undefined) return;
      this.internalValue = newValue;
      if (this.$refs && this.$refs.input)
        this.$refs.input.value = newValue == null ? "" : String(newValue);
    },
    modelValue(newValue) {
      this.internalValue = newValue;
      if (this.$refs && this.$refs.input)
        this.$refs.input.value = newValue == null ? "" : String(newValue);
    },
  },
  mounted() {
    if (this.$refs && this.$refs.input) {
      const currentValue = this.internalValue;
      this.$refs.input.value = currentValue == null ? "" : String(currentValue);
    }
  },
  methods: {
    onInput(event) {
      const inputValue = event && event.target ? event.target.value : event;
      this.internalValue = inputValue;
      this.emitModel(inputValue);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/abstracts/mixins";
@import "../styles/field-shared";

.text-field {
  width: 100%;
}
</style>
